const location = (data) => {
    let transformed;

    if (data.geo_location) {
        const [lat, lng] = data.geo_location.split(',');

        transformed = {
            lat,
            lng,
        };

        delete data.geo_location;
    }

    return {
        ...data,
        ...transformed,
    };
};

const clinical_trial = (data) => { /* eslint-disable-line camelcase */
    let transformed;

    if (data.geo_location) {
        const [lat, lng] = data.geo_location.split(',');

        transformed = {
            lat,
            lng,
        };

        delete data.geo_location;
    }

    return {
        ...data,
        ...transformed,
    };
};

const personnel = (data) => {
    Object.keys(data).forEach((item) => {
        if (data[item] === 'true' || data[item] === false) {
            data[item] = data[item] === true;
        }
    });

    data.alt = `A picture of ${data.title}`;

    if (! data.image) {
        // TODO: CDN URL? How do?
        data.image = '/assets/images/global/personnel-default.jpg';
        data.alt = 'No portrait';
    }

    return data;
};


export default {
    location,
    clinical_trial,
    personnel,
};
